import { createAction } from "@reduxjs/toolkit";

export const getStatisticsCommon = createAction("getStatisticsCommon");
